//Library imports
import styled from "styled-components";
import { Tag } from "antd";
//Local imports
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as OpenEmail } from "../../../assets/img/icons/Open_Email.svg";
import { ReactComponent as Send } from "../../../assets/img/icons/Send (5).svg";
import { ReactComponent as Eye } from "../../../assets/img/icons/eye.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
import { ReactComponent as MenuIcon } from "../../../assets/img/icons/Elipsis.svg";
interface PopoverCardProps {
  images?: String[];
  heading?: String;
  dateRed?: String;
  dateGrey?: String;
}

const PopoverCard: React.FC<PopoverCardProps> = (props) => {
  return (
    <Wrapper>
      <ImageCollection>
        <div
          className="left-column-image image-item image-left clickable top-left-border-radius"
          style={{
            backgroundImage: `url(${
              props.images
                ? props.images[0]
                : "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=752&q=80"
            })`,
          }}
        ></div>
        <div className="d-flex flex-column image-right clickable">
          <div
            className="image-item image-right top-right-border-radius border-bottom-on-image"
            style={{
              backgroundImage: `url(${
                props.images
                  ? props.images[1]
                  : "https://images.unsplash.com/photo-1508235394993-cbfa5d717584?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1882&q=80"
              })`,
            }}
          ></div>
          <div
            className="image-item image-right"
            style={{
              backgroundImage: `url(${
                props.images
                  ? props.images[2]
                  : "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=753&q=80"
              })`,
            }}
          ></div>
        </div>
      </ImageCollection>
      <div className="border-radius bg-color">
        <div className="text-styling">{props.heading ? props.heading : "Asset name and can be 2 lines long"}</div>
        <div className="text-styling-small d-flex  align-items-center">
          Digest Email&nbsp;|&nbsp;{props.dateRed ? props.dateRed : "13 Days ago"}
          <div className="text-stylimg-small-grey">
            &nbsp;|&nbsp;{props.dateGrey ? props.dateGrey : "3 days ago"}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div className="icon-spacing d-flex align-items-center">
            <div className="icon-styling">
              <Audience />
              <div className="icon-text-styling">123</div>
            </div>
            <div className="icon-styling">
              <OpenEmail />
              <div className="icon-text-styling">123</div>
            </div>
            <div className="icon-styling">
              <Send />
              <div className="icon-text-styling">123</div>
            </div>
            <div className="icon-styling">
              <Eye />
              <div className="icon-text-styling">123</div>
            </div>
            <div className="icon-styling">
              <Click />
              <div className="icon-text-styling">123</div>
            </div>
          </div>
          <div>
            <div className="menu-icon d-flex justify-content-center clickable">
              <MenuIcon />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default PopoverCard;

const Wrapper = styled.div`
  width: 250px;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  border-radius: 0 0 10px 10px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 0 0 6px 6px;
    width: 225px;
  }
  .border-radius {
    border-radius: 0 0 10px 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 0 0 6px 6px;
    }
  }
  .menu-icon {
    width: 20px;
  }
  .bg-color {
    background-color: rgb(255, 255, 255);
    padding: 1em;
  }
  .clickable {
    cursor: pointer;
  }
  .menu-icon {
    svg {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 3px;
      }
    }
  }
  .icon-styling {
    margin: 0 0.75em;
    text-align: center;
    svg {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 16px;
      }
    }
    .icon-text-styling {
      color: #5e7079;
      font-size: 12px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 700;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 8px;
      }
    }
  }
  .text-styling {
    font-size: 22px;
    color: #424b50;
    line-height: 1.091;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .text-styling-small {
    line-height: 2.185;
    font-size: 12px;
    font-weight: 700;
    color: #db3725;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
    }
    .text-stylimg-small-grey {
      color: #7e7e7e;
    }
  }
`;
const ImageCollection = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  .image-item {
    background-repeat: no-repeat;
    background-size: cover;
  }
  .image-left {
    height: 135px;
    width: 170px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 110px;
      width: 145px;
    }
  }
  .image-right {
    height: 135px;
    width: 80px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 110px;
    }
  }
  .green-background {
    background: #27ce0a;
    width: 11px;
    height: 120px;
    border-radius: 6px 0px 0px 6px;
  }
  .top-right-border-radius {
    border-radius: 0px 10px 0px 0px;
  }
  .top-left-border-radius {
    border-radius: 10px 0px 0px 0px;
  }
  .left-column-image {
    border-left: 1px solid white;
    border-right: 1px solid white;
  }
  .border-bottom-on-image {
    border-bottom: 1px solid white;
  }
`;
